import { makeStyles } from "@material-ui/core";
const FTLSectionHeaderStyles = makeStyles(() => ({
    root: {
        backgroundColor: "#F9FAFA",
        padding: "8px",
        position: "sticky",
        left: 0,
        display: "flex",
        justifyContent: "space-between",
        "&:hover": {
            backgroundColor: "#F5F9FF",
        },
    },
    contentWrapper: {
        paddingTop: "2px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
    },
    buttonsWrapper: {
        display: "flex",
        alignItems: "flex-start",
    },
    counterLayer: {
        paddingTop: "4px",
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
    },
    counterItem: {
        fontSize: "14px",
        lineHeight: "20px",
        fontWeight: 400,
        margin: 0,
    },
    title: { margin: 0 },
}));
export default FTLSectionHeaderStyles;
//# sourceMappingURL=FTLSectionHeaderStyles.styles.js.map